/**
 * External dependencies.
 */
import { __ } from '@wordpress/i18n';
import {
	InspectorControls,
	useBlockProps,
} from '@wordpress/block-editor';
import {
	PanelBody,
} from '@wordpress/components';

export default ( { attributes: { } } ) => {
	const blockProps = useBlockProps( {
		style: {
			fontFamily: 'var(--portal-font-family)',
		},
		className: 'suredash-portal__editor-content portal-content-area portal-content sd-box-shadow entry-content portal-content-type-wordpress  portal-editor-skeleton',
	} );

	return (
		<>
			<InspectorControls>
				<PanelBody>

				</PanelBody>
			</InspectorControls>

			<div { ...blockProps }>
				<p> { __( 'Content will appear in the space area as per the space type.', 'suredash' ) } </p>
			</div>
		</>
	);
};
